<script>
  import { impression, trackEvent } from '../util/snowplow';

  export let big = false;
  const url =
    'https://www.nrk.no/kultur/anmeldelse_-melodi-grand-prix-_mgp_-2024_-latene-fra-andre-delfinale-1.16716356';
  const campaign = `/?utm_source=delta&utm_medium=${big ? 'promo_with_image' : 'promo_no_image'}&utm_campaign=mgp`;
</script>

{#if big}
  <a
    class="further-navigation-big"
    href={url + campaign}
    target="_blank"
    on:click={() =>
      trackEvent({ action: 'click:further-navigation-with-image' })}
    use:impression={'promo:image'}
  >
    <img
      src="https://gfx.nrk.no/xcAUiOXUURbP2AOIs57KZwzX5a9nEsvp-gl6FFvLg6mw.png"
      alt="MGP 2024 delfinale 2"
    />
    <div class="text">
      <div class="icon">Les på NRK.no</div>
      <div>Er du enig med anmelderne?</div>
      <div class="text-small">«Les anmeldelsen her»</div>
    </div>
  </a>
{:else}
  <a
    class="further-navigation"
    href={url + campaign}
    target="_blank"
    on:click={() => trackEvent({ action: 'click:further-navigation-no-image' })}
    use:impression={'promo:no-image'}
    >Er du enig med anmelderne? <br />
    <span> Les anmeldelse på nrk.no </span></a
  >
{/if}

<style>
  .further-navigation {
    text-align: center;
    margin-top: 4rem;
  }

  .further-navigation > span {
    text-decoration: underline;
  }

  .further-navigation-big {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 31rem;
  }
  img {
    width: 100%;
  }
  .text {
    text-align: start;
    background: var(--mgp-purple-900);
    padding: 0.8rem;
    width: 100%;
    font-size: 1.5rem;
  }
  .icon {
    width: fit-content;
    border-radius: 2px;
    font-weight: 600;
    font-size: 0.8rem;
    color: darkblue;
    padding: 0.1rem 0.2rem;
    background: #b2cff5;
    margin-bottom: 0.2rem;
  }
  .text-small {
    position: relative;
    font-size: 0.9rem;
  }
</style>
